import {
  Agent,
  noopWorkspaceDomainLoader,
  resolveNoFolder,
  type DG,
} from '@cotera/sdk/core';
import type { AgentApiData } from './use-agent-query';

function parseEditorState(raw: unknown): DG.DocumentEditor.DocumentState {
  const parsed = raw as DG.DocumentEditor.DocumentState;
  if (
    parsed !== null &&
    typeof parsed === 'object' &&
    'type' in parsed &&
    parsed.type === 'doc'
  ) {
    return parsed;
  }
  return { type: 'doc', content: [] };
}

export function agentFromApiData(data: AgentApiData): Agent {
  return Agent.fromData(
    {
      ownerId: data.ownerId,
      id: data.id,
      orgId: data.orgId,
      editorState: parseEditorState(data.editorState),
      model: data.model,
      description: null,
      agentKey: data.agentKey ?? `agent-${data.id?.replace(/-/g, '')}`,
      lockedBy: data.locked ? 'system' : null,
      createdAt:
        data.createdAt instanceof Date
          ? data.createdAt
          : new Date(data.createdAt),
      updatedAt:
        data.updatedAt instanceof Date
          ? data.updatedAt
          : new Date(data.updatedAt),
    },
    {
      loadFolder: resolveNoFolder,
      workspaceDomainLoader: noopWorkspaceDomainLoader,
    }
  );
}
